<ng-container *ngIf="canView">
    <mat-expansion-panel *ngIf="!isValidating" [expanded]="true" style="margin: 10px 0px;">

        <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px; margin-right: 5px;">attach_money</mat-icon>
                Resumen de Saldo
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <div fxLayout="row stretch" fxLayout.xs="column">

          <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item">

            <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>

            <ng-container *ngIf="!isSearching">

              <mat-expansion-panel [expanded]="true" hideToggle="true" style="padding-top: 17px;">

                <ng-container *ngIf="!mostrarTotales">
                  <mat-label style="margin: 10px 0px 0px 10px;">
                    No tiene movimientos registrados.
                  </mat-label>
                </ng-container>

                <ng-container *ngIf="mostrarTotales">
                  <mat-label *ngFor="let item of totales | keyvalue" style="margin: 10px 0px 0px 10px;">
                    <b>{{item.key}}:</b> <span style="margin-left: 5px;" [ngStyle]="{ color: (item.value < 0) ? 'indianred' : 'black' }">{{item.value | number: '1.2-2'}}</span> <br/>
                  </mat-label>
                </ng-container>

              </mat-expansion-panel>

            </ng-container>

          </div>

        </div>

    </mat-expansion-panel>
</ng-container>